import { DateTimeLocalizationInfo, DateTimeUtcService, Duration, DurationService, TimeService } from '@mews/framework';
import { ReleaseStrategy, ReleaseStrategyParameters } from '@mews-commander/data-access';
import { earliestDayTime, getDateTimeUtc } from '@mews-commander/utils';

export const getBookerScope = (form: string) => `booker-${form}`;
export const getCompanyScope = (form: string) => `company-${form}`;
export const getTravelAgencyScope = (form: string) => `travel-agency-${form}`;

export const isEqualUtc = (firstUtcString: string, secondUtcString: string) => {
    const firstDateTimeUtc = DateTimeUtcService.parse(firstUtcString);
    const secondDateTimeUtc = DateTimeUtcService.parse(secondUtcString);
    return DateTimeUtcService.isEqual(firstDateTimeUtc, secondDateTimeUtc);
};

export const getDayCountFromDuration = (duration: Duration) => Math.ceil(DurationService.asDays(duration));
export const getShortTimeStringFromDuration = (duration: Duration, localizationInfo: DateTimeLocalizationInfo) => {
    const hours = -DurationService.hours(duration);
    const minutes = -DurationService.minutes(duration);
    const time = TimeService.addMinutes(TimeService.addHours(earliestDayTime, hours), minutes);
    return TimeService.toShortString(time, localizationInfo);
};

export const getDurationFromDaysAndTime = (
    dayCount: number,
    shortTimeString: string,
    localizationInfo: DateTimeLocalizationInfo
) => {
    const parsedTime = TimeService.fromShortString(shortTimeString, localizationInfo);
    return DurationService.fromObject({
        days: dayCount,
        hours: -TimeService.getHours(parsedTime),
        minutes: -TimeService.getMinutes(parsedTime),
        seconds: -TimeService.getSeconds(parsedTime),
    });
};

export const getReleaseStrategy = ({
    blockReleaseStrategy,
    timezone,
    localizationInfo,
    date,
    time,
    offsetDays,
    offsetTime,
}: {
    blockReleaseStrategy: ReleaseStrategy;
    timezone: string;
    localizationInfo: DateTimeLocalizationInfo;
    date: string;
    time: string;
    offsetDays: number;
    offsetTime: string;
}): ReleaseStrategyParameters['releaseStrategy'] => {
    switch (blockReleaseStrategy) {
        case ReleaseStrategy.FixedReleaseUtc:
            return {
                discriminator: ReleaseStrategy.FixedReleaseUtc,
                value: getDateTimeUtc({ timezone, localizationInfo, date, time }),
            };
        case ReleaseStrategy.RollingReleaseOffset:
            return {
                discriminator: ReleaseStrategy.RollingReleaseOffset,
                value: DurationService.toString(getDurationFromDaysAndTime(offsetDays, offsetTime, localizationInfo)),
            };
        default:
            return {
                discriminator: ReleaseStrategy.None,
                value: {},
            };
    }
};
